import React, { useState } from "react";
import Row from "../../components/Row";
import Column from "../../components/Column";
import TitleUnderlined from "../../components/TitleUnderlined";
import Button from "../../components/Button";
import Form from "../../components/Form";
import { Link, useNavigate } from "react-router-dom";
import { RoutesWeb } from "../../tools/RoutesWeb";
import APIInterface from "../../tools/APIInterface";
import CloudError from "../../tools/ClourError";
import User from "../../models/User";
import Swal from "sweetalert2";
import Utils from "../../tools/Utils";
import Breadcrumb from "../../components/Breadcrumb";

const AddLeaderView = () => {
    const token = localStorage.getItem('tokenAdmin');
    const [user, setUser] = useState(new User());
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleData = (e) => {
        let newUser = user;
        user[e.target.name] = e.target.value;
        setUser(newUser);
    }

    const handleSubmit = () => {
        if(document.getElementById('password').value === document.getElementById('confirm_password').value){
            if(!isLoading) {
                setIsLoading(true);
                APIInterface.addUser(token, user)
                .then((response) => {
                    if(response.status === 200){
                        Swal.fire({
                            title: "Correcto",
                            text: "El líder se ha agregado",
                            icon: 'success',
                            confirmButtonText: 'Confirmar',
                        })
                        .then((result) => {
                            navigate(RoutesWeb.ADMIN_DASHBOARD);
                        })
                        .catch((er) => {
                            setIsLoading(false);
                            console.log(er);
                        })
                    }
                    console.log(response);
                })
                .catch((error) => {
                    console.error(error);
                    setIsLoading(false);
                    CloudError.error(error);
                });
            }
        } else {
            Utils.Toast.fire({title: 'Ups', text: 'Las contraseñas no coinciden', icon: 'error'});
        }
    }

    return(
        <div className="pt-5 pb-5" id="addLeaderView">
            <br />
            <br />
            <Breadcrumb items={[
                {
                    title: 'Dashboard',
                    route: RoutesWeb.ADMIN_DASHBOARD
                },
                {
                    title: 'Nuevo Líder',
                    active: true
                },
            ]} />
            <Row>
                <Column className="col-md-6">
                    <TitleUnderlined>Nuevo <span className="embercom_overlined">Líder</span></TitleUnderlined>
                    <br />
                    <br />
                    {/* <p>Inicia tu sesión como administrador.</p> */}
                    <Form submitCallback={handleSubmit} isLoadingCallback={(isLoading) => {
                        setIsLoading(isLoading);
                    }}>
                        <div className="form-group">
                            <label className="semibold" htmlFor="name">Nombre</label>
                            <input type="text" required id="name" name="name" className="form-control" onChange={handleData} />
                        </div>
                        <div className="form-group">
                            <label className="semibold" htmlFor="email">Usuario</label>
                            <input type="email" required id="email" name="email" className="form-control" onChange={handleData} />
                        </div>
                        <div className="form-group">
                            <label className="semibold" htmlFor="phone_number">Número telefónico</label>
                            <input type="text" required id="phone_number" name="phone_number" className="form-control" onChange={handleData} />
                        </div>
                        <div className="form-group">
                            <label className="semibold" htmlFor="password">Contraseña</label>
                            <input type="password" required id="password" name="password" className="form-control" onChange={handleData} />
                        </div>
                        <div className="form-group">
                            <label className="semibold" htmlFor="confirm_password">Confirmar Contraseña</label>
                            <input type="password" required id="confirm_password" name="confirm_password" className="form-control" onChange={handleData} />
                        </div>
                        <br />
                        <Row>
                            <Column className="col-md-6">
                                <Button className="py-2 w-100 d-flex justify-content-between align-items-center">Registrar <img src={require('../../assets/arrow_next.png')} alt="arrowNext" style={{marginLeft: '2rem'}} /></Button>
                            </Column>
                            <Column className="col-md-6 d-flex justify-content-end align-items-center">
                                <h4 style={{marginBottom: '0px'}}><Link style={{color: 'black'}} to={RoutesWeb.ADMIN_DASHBOARD}><img src={require('../../assets/arrow_black.png')} width="25" height="17" alt="back" /> Regresar</Link></h4>
                            </Column>
                        </Row>
                    </Form>
                </Column>
                <Column className="col-md-6 d-flex justify-content-center align-items-start">
                    <img src={require('../../assets/img4.png')} alt="Img" style={{width: '100%', maxWidth: '430px'}} />
                </Column>
            </Row>
            <br />
            <br />
        </div>
    )
}

export default AddLeaderView;